<template>
    <div :class="{...marginTopClass, ...sizeClasses, ...displayClasses}">
        <slot></slot>
    </div>
</template>

<script>
    import sizeClassesMixin from "./mixin/sizeClassesMixin";
    import displayClassesMixin from "./mixin/displayClassesMixin";

    export default {
        name: "Column",
        mixins: [sizeClassesMixin, displayClassesMixin],
        computed: {
            marginTopClass() {
                let result = {};

                if (this.xlSize !== "1" && !this.noMarginTop) {
                    result['mt-3 mt-sm-0'] = true
                }

                return result
            },
        },
        props: {
            noMarginTop: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style scoped>

</style>